import React, { memo } from 'react'
import { FormattedMessage } from 'react-intl'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Image from 'components/shared/Image'
import dynamic from 'next/dynamic'
import Button from '@mui/material/Button'
import IconButton from '@mui/material/IconButton'
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew'
import clsx from 'clsx'
import EventEmitter from 'services/EventEmitter'
import PDFViewer from 'components/VTA/PDFViewer'
import sx from './styles'

const DisclaimerDynamic = dynamic(() => import('components/shared/Disclaimer'))

const ImageAndTitle = ({
  img,
  title,
  formatTitle = true,
  description,
  reverseDescription,
  showMainImage,
  reverseForm,
  disclaimer,
  showButtonDisclaimer = false,
  onClickDisclaimer,
  showButton = false,
  sx: sxProp,
  isBigPhoto = false,
  isPdf = false,
  directSelling = false,
}) => {
  const handleBackClick = () => {
    EventEmitter.emit('back-to-dig-exp')
  }

  const handleClickDisclaimer = () => {
    if (onClickDisclaimer && typeof onClickDisclaimer === 'function') {
      onClickDisclaimer()
    }
  }

  const imageBlock = (
    <Box
      sx={{ ...sx.imageContainer, ...sxProp }}
      className={clsx({
        reverse: reverseForm,
        isBigPhoto,
      })}
    >
      <Image
        src={img}
        alt="ejemplo identificación de frente"
        title="ejemplo identificación de frente"
        height={200}
        width={320}
        layout="fill"
        objectFit={reverseForm ? 'contain' : 'cover'}
        priority
        unoptimize
      />

      {(!reverseForm && showButton) && (
        <IconButton
          onClick={handleBackClick}
          sx={sx.backIcon}
        >
          <ArrowBackIosNewIcon />
        </IconButton>
      )}

    </Box>
  )

  const pdfBlock = (
    <Box
      sx={{ ...sx.imageContainer, ...sxProp }}
      className={clsx({
        reverse: reverseForm,
        isBigPhoto,
      })}
    >
      <Box>
        <PDFViewer
          file={img}
          width="100%"
          height="100%"
        />
      </Box>
    </Box>
  )

  const titleAndDescription = (
    <>
      {!reverseForm && (
        <Typography
          variant="subtitle1"
          sx={{ ...sx.title, ...sx.weightBold }}
        >
          {formatTitle ? (
            <FormattedMessage id={title} />
          ) : (title)}

        </Typography>
      )}

      <Typography
        variant="body1"
        mt={1}
        sx={directSelling ? sx.weightBold : ''}
      >
        <FormattedMessage id={
          reverseForm
            ? reverseDescription
            : description
        }
        />
      </Typography>

      {reverseForm && img && (
        <Box mt={2}>
          {isPdf
            ? (pdfBlock)
            : (imageBlock)}
        </Box>
      )}
    </>
  )

  return (
    <>
      {(showMainImage && !reverseForm) && (imageBlock)}

      <Box p={2}>
        {titleAndDescription}

        {disclaimer && !reverseForm && (
          <DisclaimerDynamic
            text={disclaimer}
            formattedText
            content={showButtonDisclaimer ? (
              <Button
                variant="text"
                onClick={handleClickDisclaimer}
                sx={{ ml: 0, pl: 0 }}
              >
                <Typography
                  variant="link-text"
                  sx={sx.linkText}
                >
                  <FormattedMessage id="DIG_EXPEDIENT_CLICK_TO_CONTINUE" />
                </Typography>
              </Button>
            ) : null}
          />
        )}
      </Box>
    </>
  )
}

export default memo(ImageAndTitle)
